import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { auditSupport } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { MRT_ColumnDef, MRT_Row } from 'material-react-table';
import { useIntl } from 'react-intl';

export type BcrPreviewProps = {
  entries: auditSupport.BcrEntryDto[];
};

export function BcrPreview({ entries }: BcrPreviewProps) {
  const { $t } = useIntl();

  const columns: MRT_ColumnDef<auditSupport.BcrEntryDto>[] = [
    {
      accessorKey: 'index',
      header: $t({ id: 'common.columnIndex', defaultMessage: '#' }),
      size: 50,
      Cell: ({ row }: { row: MRT_Row<auditSupport.BcrEntryDto> }) => row.index + 1,
      enableSorting: false,
      enableColumnFilter: false,
    },
    createDateTimeColumn<auditSupport.BcrEntryDto>($t, {
      accessor: (row) => row.datetime,
      size: 200,
    }),
    {
      accessorKey: 'type',
      header: $t({ id: 'common.type', defaultMessage: 'Tipo' }),
      size: 150,
    },
    createCustomIdColumn<auditSupport.BcrEntryDto>($t, {
      accessor: (row) => row.customId,
      size: 200,
    }),
    {
      accessorKey: 'name',
      header: $t({ id: 'common.name', defaultMessage: 'Nombre' }),
      size: 250,
    },
  ];

  return (
    <Box mt={3}>
      <MrtTable
        columns={columns}
        data={entries}
        enableSorting
        enableColumnFilters
        enableGlobalFilter
        initialState={{
          density: 'compact',
          pagination: { pageSize: 50, pageIndex: 0 },
        }}
      />
    </Box>
  );
}
